import { cartV2 } from '@wix/ecom';

export class CatalogReferenceModel {
  public catalogItemId?: string;

  constructor(catalogReferenceModel: CatalogReferenceModel) {
    this.catalogItemId = catalogReferenceModel.catalogItemId;
  }

  public static fromV2(catalogReference?: cartV2.CatalogReference) {
    return new CatalogReferenceModel({
      catalogItemId: catalogReference?.catalogItemId,
    });
  }
}
